import { API } from "../axios/API";

const postPropsRegisters = async (newData, typeChrage) => {
  try {
    // Convierte el archivo a Base64
    const base64File = await new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(newData);
      reader.onload = () => resolve(reader.result);
      reader.onerror = error => reject(error);
    });

    const resp = await API.post("/creaciontitulos/cargarregsitrosinmuebles", { file: base64File, typeChrage: typeChrage }, {
      headers: {
        "Content-Type": "application/json",
      },
    });
    return resp;
  } catch (err) {
    console.error("Error al enviar el archivo:", err);
    return err.response;
  }
};

const postGenerateXLS = async (newData, category) => {
  try {
    // Convierte el archivo a Base64
    const base64File = await new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(newData);
      reader.onload = () => resolve(reader.result);
      reader.onerror = error => reject(error);
    });

    const resp = await API.post("/creaciontitulos/generatexls", { file: base64File, category: category }, {
      headers: {
        "Content-Type": "application/json",
      },
    });
    return resp;
  } catch (err) {
    console.error("Error al enviar el archivo:", err);
    return err.response;
  }
};

const postGenerateTitles = async (newData, category, userDNI, startTitleNumber) => {
  try {
    // Convierte el archivo a Base64
    const base64File = await new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(newData);
      reader.onload = () => resolve(reader.result);
      reader.onerror = error => reject(error);
    });

    const resp = await API.post("/creaciontitulos/generatetitles", 
      { file: base64File, category: category, userDNI: userDNI, startTitleNumber: startTitleNumber }, 
      {
        headers: {
          "Content-Type": "application/json",
        },
        responseType: "blob",
      });
    return resp;
  } catch (err) {
    console.error("Error al enviar el archivo:", err);
    return err.response;
  }
};

const getTitlesInfo = async (queryParams) => {
  try {
    const resp = await API.get(`/creaciontitulos/titulosinfo?${queryParams}`);
    return resp;
  } catch (err) {
    console.error("Error al obtener la información:", err);
    return err.response;
  }
};

const getUsersInfo = async () => {
  try {
    const resp = await API.get("/creaciontitulos/userstitulosfilter");
    return resp;
  } catch (err) {
    console.error("Error al obtener la información:", err);
    return err.response;
  }
};

const getAbogadosInfoFilter = async () => {
  try {
    const resp = await API.get("/creaciontitulos/getabogadosinfofilter");
    return resp;
  } catch (err) {
    console.error("Error al obtener la información:", err);
    return err.response;
  }
};

const getXlsBase = async () => {
  try {
    const resp = await API.get("/creaciontitulos/getxlsexample",
      {responseType: "blob"});
    return resp;
  } catch (err) {
    console.error("Error al obtener la información:", err);
    return err.response;
  }
};

const getLastTitleNumber = async () => {
  try {
    const resp = await API.get("/creaciontitulos/getlastitlenumber");
    return resp;
  } catch (err) {
    console.error("Error al obtener la información:", err);
    return err.response;
  }
};

const getTitleInfo = async (queryParams) => {
  try {
    const resp = await API.get(`/creaciontitulos/gettitlebynum?${queryParams}`);
    return resp;
  } catch (err) {
    console.error("Error al obtener la información:", err);
    return err.response;
  }
};

const updateTitleInfo = async (data) => {
  try {
    const resp = await API.put("/creaciontitulos/updatetitleinfo", { data }, {
      headers: {
        "Content-Type": "application/json",
      },
      responseType: "blob",
    });
    return resp;
  } catch (err) {
    console.error("Error al obtener la información:", err);
    return err.response;
  }
};

const printTitle = async (queryParams) => {
  try {
    const resp = await API.get(`/creaciontitulos/printtitle?${queryParams}`, {
      // headers: {
      //   "Content-Type": "application/json",
      // },
      responseType: "blob",
    });
    return resp;
  } catch (err) {
    console.error("Error al obtener la información:", err);
    return err.response;
  }
};

export const CreacionTitulosService = {
  postPropsRegisters,
  postGenerateXLS,
  postGenerateTitles,
  getTitlesInfo,
  getUsersInfo,
  getAbogadosInfoFilter,
  getXlsBase,
  getLastTitleNumber,
  getTitleInfo,
  updateTitleInfo,
  printTitle
};
